<template>
	<v-navigation-drawer
		:value="drawer"
		fixed
		app
		:dark="dark"
		:clipped="clipped"
		@input="onInput"
	>
		<v-list dense>
			<slot></slot>
		</v-list>
	</v-navigation-drawer>
</template>

<script>
export default {
	props: {
		value: Boolean,
		clipped: Boolean,
		dark: Boolean,
	},
	computed: {
		drawer() {
			return this.value
		},
	},
	methods: {
		onInput(event) {
			this.$emit('input', event)
		},
	},
}
</script>
